import '../styles/Header.css';
function Header() {

  return (
    <div className="Header">
      <div id='ods-logo'>
        <img src={require(`../assets/imagenes/items/ods-titulo.jpg`)} alt="ods-logo" />
      </div>
      <div id='ods-titulo' style={{ fontWeight: 'bold' }}>EVALUANDO LA CONTRIBUCIÓN DE SU PRODUCTO ACADÉMICO A LOS ODS</div>
      <div id='ods-sotenibilidad'>
        <img src={require(`../assets/imagenes/items/espol_sostenibilidad.png`)} alt="ods-sostenibilidad" />
      </div>
    </div>

  )
}

export default Header;
